import React from "react";
import { useQuery } from "@tanstack/react-query";
import { api } from "@/lib/api";
import { Plug, CheckCircle2, AlertTriangle, Clock } from "lucide-react";

const ICON = {
  connected: <CheckCircle2 size={14} className="text-[#6BB88A]"/>,
  degraded: <AlertTriangle size={14} className="text-[#C99A2E]"/>,
  pending_activation: <Clock size={14} className="text-[#7CBFDC]"/>,
};

export const IntegrationHub = () => {
  const { data, isLoading } = useQuery({
    queryKey: ["integration-status"],
    queryFn: async () => (await api.get("/integration/status")).data,
  });

  return (
    <div className="space-y-6" data-testid="page-integration">
      <header>
        <div className="font-mono-cad text-[10px] uppercase tracking-[0.28em] text-[#7C93A5]">Inter-Ministerial Integration Hub</div>
        <h1 className="font-display text-3xl font-bold text-[#F6F8FA] mt-1 flex items-center gap-2">
          <Plug className="text-[#C99A2E]"/> Sovereign Integration Bus
        </h1>
        <div className="text-[13px] text-[#B3C2CC] mt-1">Secure interfaces to Surveyor-General, Deeds Registry, Mines, ZIMRA, Treasury, EMA, national mapping and identity services.</div>
      </header>

      {isLoading || !data ? (
        <div className="cad-panel p-6 text-[13px] text-[#B3C2CC]">Polling integration bus…</div>
      ) : (
        <>
          <div className="grid grid-cols-3 gap-3">
            {["connected", "degraded", "pending_activation"].map((k) => (
              <div key={k} className="cad-panel p-4">
                <div className="font-mono-cad text-[10px] uppercase tracking-[0.22em] text-[#7C93A5]">{k.replace(/_/g, " ")}</div>
                <div className="cad-kpi-value text-3xl mt-1" style={{
                  color: k === "connected" ? "#6BB88A" : k === "degraded" ? "#C99A2E" : "#7CBFDC",
                }}>{data.counts[k] || 0}</div>
              </div>
            ))}
          </div>

          <div className="cad-panel overflow-hidden">
            <table className="w-full text-[13px]">
              <thead>
                <tr className="text-left border-b cad-hairline">
                  {["Institution","System","Protocol","Status","Latency","Last sync","Records"].map((h) => (
                    <th key={h} className="px-3 py-2.5 font-mono-cad text-[10px] uppercase tracking-[0.18em] text-[#7C93A5]">{h}</th>
                  ))}
                </tr>
              </thead>
              <tbody className="cad-tbody">
                {data.integrations.map((i) => (
                  <tr key={i.code} data-testid={`integration-${i.code}`}>
                    <td className="px-3 py-2.5 text-[#F6F8FA]">{i.name}</td>
                    <td className="px-3 py-2.5 text-[#DCE3E8]">{i.system}</td>
                    <td className="px-3 py-2.5 font-mono-cad text-[#B3C2CC]">{i.protocol}</td>
                    <td className="px-3 py-2.5">
                      <span className="inline-flex items-center gap-1.5">{ICON[i.status]}
                        <span className={`cad-chip ${i.status === "connected" ? "cad-chip-green" : i.status === "degraded" ? "cad-chip-gold" : "cad-chip-blue"}`}>{i.status.replace(/_/g, " ")}</span>
                      </span>
                    </td>
                    <td className="px-3 py-2.5 font-mono-cad">{i.latency_ms == null ? "—" : `${i.latency_ms} ms`}</td>
                    <td className="px-3 py-2.5 font-mono-cad text-[#B3C2CC]">{i.last_sync}</td>
                    <td className="px-3 py-2.5 font-mono-cad text-[#B3C2CC]">{i.records}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
          <div className="text-[10px] font-mono-cad uppercase tracking-[0.18em] text-[#7C93A5]">{data.note}</div>
        </>
      )}
    </div>
  );
};
